import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { CurrencyWithPlaceholderFallback } from './CurrencyWithPlaceholderFallback';

export const FullTermRepaymentRow = ({ amount }: { amount: number | null }) => (
    <div className="flex items-center justify-between">
        <Text>
            <FormattedMessage
                id="_.loan_summary.full_term_repayment"
                defaultMessage="Full term repayment:"
            />
        </Text>
        <Text className="font-bold">
            <CurrencyWithPlaceholderFallback value={amount} />
        </Text>
    </div>
);
